var _style, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarTooltip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000183228793616714611420000005066824232539783834_);}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:2;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072972940530162763300000015142390315657021627_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000072972940530162763300000015142390315657021627_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.5,43.3c2.8,0,5,2.1,5,4.5s-2.2,4.5-5,4.5c-2.9,0-5-2.1-5-4.5S60.6,43.3,63.5,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.5,43.3c2.8,0,5,2.1,5,4.5s-2.2,4.5-5,4.5s-5-2.1-5-4.5S15.7,43.3,18.5,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.5,27.8c4.8,0.8,11,5,15,7c12.5,0,18.7,3.3,19.5,5v5.5h1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74,45.3c0,1.7-0.3,3-1,4h-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.5,48.8c-1.7,0-6.4-0.3-8-1.5s-0.7-4.5,0-6v-7l5-4v-2c10.4-2,23.7-1.3,29-0.5 M58.5,48.8H24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17,36c-4-0.1-5.3-0.7-5-1l1.9-3.2c0.5-0.3,5.1-1.9,9.1-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48,36.6L16.5,36"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarTooltip);
export default __webpack_public_path__ + "static/media/car_tooltip.c4f4ea6d8915516eafadf55e51a1da14.svg";
export { ForwardRef as ReactComponent };